export const normalizeImageUrl = (value) => {
  if (typeof value !== 'string') return '';

  const trimmed = value.trim();
  if (!trimmed) return '';

  return trimmed.replace(/^https?:\/\/localhost:5000\/uploads\//i, '/uploads/');
};

export const imageLooksUsable = (value) => {
  const image = normalizeImageUrl(value);

  return Boolean(image)
    && (/^https?:\/\//i.test(image) || image.startsWith('/uploads/') || image.startsWith('/images/'))
    && !image.includes('example.com')
    && !image.includes('via.placeholder.com');
};

export const getProductImage = (product = {}) => {
  const imageCandidates = [
    product.image,
    ...(Array.isArray(product.images) ? product.images : []),
  ];

  const image = imageCandidates.find(imageLooksUsable) || '';
  return normalizeImageUrl(image);
};
